import { InjectionToken } from '@angular/core';

/**
 * Injection token for the API base URL used by dashboard components that need to make
 * direct HTTP calls (e.g. loading action forms via selectionRoute).
 *
 * Provide this alongside BASE_PATH in any module that uses DashboardModule:
 *   { provide: DASHBOARD_API_BASE_PATH, useExisting: BASE_PATH }
 *
 * Example resolved value: '../_api/rest'
 */
export const DASHBOARD_API_BASE_PATH = new InjectionToken<string>('dashboardApiBasePath');
